<template>
  <div class="size-picker">
    <div
      class="box"
      @click="showRange = !showRange; $emit('menuopen')"
    >
      <i class="fas fa-circle box__icon" />
      {{ label }}
    </div>
    <div
      v-if="showRange"
      class="size-picker__box"
    >
      <div
        v-for="(size, index) in sizes"
        :key="index"
      >
        <svg
          :class="isSelected(size)"
          height="6.75rem"
          width="100%"
          @click="setSize(size)"
        >
          <circle
            :r="size / 2"
            cx="50%"
            cy="3.375rem"
            fill="black"
            stroke-width="0"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    close: {
      type: Boolean,
      default: false,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      showRange: false,
      sizes: [6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96]
    };
  },

  computed: {
    brushSize: {
      set: function(newValue) {
        this.$emit("input", Number(newValue));
      },
      get: function() {
        return this.value;
      }
    }
  },

  watch: {
    close: function() {
      this.showRange = false;
    }
  },

  methods: {
    setSize: function(newSize) {
      this.brushSize = newSize;
      this.showRange = false;
      this.$emit("selected");
    },
    isSelected: function(size) {
      if (size == this.brushSize) return "selected-size";
      return "";
    }
  }
};
</script>

<style lang="scss">
.size-picker {
  position: relative;
  align-items: center;
  display: flex;

  &__box {
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 3.5rem;
    left: -8.5rem;
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    margin: auto;
    padding: 0.25rem;
    width: 28rem;
    z-index: 21;
  }
}

.selected-size {
  $active-color: #398992;
  background: lighten(#398992, 55%);
  border-radius: 1rem;
  border-color: $active-color;
  box-shadow: inset 0 0px 10px rgba($active-color, 0.8);
}
</style>
